import { stringify } from "qs";
import { fetch } from "$utils/utils";

export enum ERRORS {}

export const getActivities = async (params) => {
  try {
    const { data } = await fetch(`/api/activities?${stringify(params)}`);

    return data.data;
  } catch (err) {
    return { error: err?.message ?? null };
  }
};
